import { Component, ViewChild } from '@angular/core';

@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss']
})
export class NavmenuComponent {
    @ViewChild('navbarLinks') navbarLinks: any;

    closeMenu() {
    if (this.navbarLinks) {
      this.navbarLinks.hidden = true;
    }
  }
}